import { Button } from '@/components/Button';
import { useModal } from '@/hooks/useModal';
import { removeAd, type AdItemType } from '@/resource/ad';
import { routeToPath } from '@/util/routeToPath';
import { useRouter } from 'next/router';

export function DeleteAdButton({ ad }: { ad: AdItemType }) {
  const router = useRouter();
  const modal = useModal();
  const label = ad.type === 'offer' ? 'Aanbod' : 'Vraag';

  return (
    <Button
      iconOnly="mobile"
      icon="trash"
      theme="secondary"
      onClick={(e, refocus) => {
        modal.open(
          {
            type: 'confirm',
            maxWidth: 40,
            props: {
              title: `Weet je zeker dat je je ${label.toLowerCase()} wilt verwijderen?`,
              description: 'Dit kan niet ongedaan worden gemaakt.',
              onCancel: () => modal.close(),
              onConfirm: () => {
                removeAd(ad)
                  .then((res) => {
                    if (res.type === 'ok') {
                      router.push(routeToPath({ type: 'profile_ads' }));
                    } else {
                      console.log(res);
                    }
                  })
                  .catch((err) => console.error(err))
                  .finally(() => modal.close());
              },
            },
          },
          refocus
        );
      }}
    >
      Verwijderen
    </Button>
  );
}
